/* Capitol style — trang danh mục (sections/gv-collection.liquid).
   - Sort By: đổi lựa chọn là tải lại danh sách theo cách sắp xếp mới (giữ bộ lọc đang chọn).
   - Nút lưới / danh sách (máy tính): nhớ lựa chọn trên máy khách.
   - Điện thoại: nút FILTER mở bảng lọc toàn màn hình, nút X / phím Esc để đóng.
   - Lọc giá: bỏ ô trống khỏi địa chỉ, tự đổi chỗ khi From > To. */
(function () {
  if (window.__gvCollection) return; window.__gvCollection = 1;

  function init(root) {
    if (!root || root.__gvc) return; root.__gvc = 1;

    var sort = root.querySelector('[data-gvc-sort]');
    if (sort) {
      var sel = sort.querySelector('select');
      if (sel) sel.addEventListener('change', function () {
        if (sort.requestSubmit) sort.requestSubmit(); else sort.submit();
      });
    }

    var btns = root.querySelectorAll('[data-gvc-view]');
    function setView(v, save) {
      if (v === 'list') root.setAttribute('data-view', 'list'); else root.removeAttribute('data-view');
      for (var i = 0; i < btns.length; i++) btns[i].setAttribute('aria-pressed', btns[i].dataset.gvcView === v ? 'true' : 'false');
      if (save) { try { localStorage.setItem('gvc-view', v); } catch (e) {} }
    }
    setView(root.getAttribute('data-view') === 'list' ? 'list' : 'grid', false);
    for (var i = 0; i < btns.length; i++) btns[i].addEventListener('click', function () { setView(this.dataset.gvcView, true); });

    var open = root.querySelector('[data-gvc-open]');
    var drawer = open && document.getElementById(open.getAttribute('aria-controls'));
    var close = drawer && drawer.querySelector('[data-gvc-close]');
    var html = document.documentElement;
    function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }
    function show() {
      root.classList.add('is-open'); open.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('role', 'dialog'); drawer.setAttribute('aria-modal', 'true');
      html.setAttribute('scroll-lock', '');
      if (close) close.focus();
    }
    function hide(focusBtn) {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open'); open.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('role', 'region'); drawer.removeAttribute('aria-modal');
      html.removeAttribute('scroll-lock');
      if (focusBtn) open.focus();
    }
    if (open && drawer) {
      open.addEventListener('click', show);
      if (close) close.addEventListener('click', function () { hide(true); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) hide(true); });
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !root.classList.contains('is-open')) return;
        var f = drawer.querySelectorAll('a[href],button,input,summary,select');
        var list = [];
        for (var k = 0; k < f.length; k++) if (f[k].type !== 'hidden' && (f[k].checkVisibility ? f[k].checkVisibility() : f[k].offsetParent !== null)) list.push(f[k]);
        if (!list.length) return;
        var first = list[0], last = list[list.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      window.addEventListener('resize', function () { if (!isMobile()) hide(false); });
      window.addEventListener('pageshow', function () { hide(false); });
    }

    var pf = root.querySelectorAll('[data-gvc-price]');
    for (var j = 0; j < pf.length; j++) pf[j].addEventListener('submit', function () {
      var ins = this.querySelectorAll('.gvc__pin');
      if (ins.length === 2) {
        var a = parseFloat(ins[0].value), b = parseFloat(ins[1].value);
        if (!isNaN(a) && !isNaN(b) && a > b) { var t = ins[0].value; ins[0].value = ins[1].value; ins[1].value = t; }
      }
      for (var k = 0; k < ins.length; k++) if (ins[k].value.trim() === '') ins[k].disabled = true;
      setTimeout(function () { for (var k = 0; k < ins.length; k++) ins[k].disabled = false; }, 0);
    });
  }

  function scan(r) { var els = (r || document).querySelectorAll('[data-gvc]'); for (var i = 0; i < els.length; i++) init(els[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
